import Http from './base-http'

class SPModule extends Http {
  updateModule(data) {
    return this.client.put(data.id, data)
  }

}

const spModule = new SPModule({
  modelUrlPrefix : 'module'
})

export default spModule
